/**
 * Мелкие настройки устройства: выбранный филиал.
 *
 * ПОЧЕМУ ЭТО МОЖНО КЛАСТЬ В localStorage, А ТОКЕН — НЕЛЬЗЯ. Здесь лежит идентификатор
 * филиала, который человеку и так виден в адресной строке и в шапке. Украсть его нечем:
 * доступ к филиалу решает сервер по членству, а не по тому, что записано на устройстве.
 * Токен — наоборот, сам по себе является доступом.
 *
 * Ключ включает салон: один и тот же человек работает администратором в одном салоне
 * и мастером в другом, и филиал у них разный.
 */

const BRANCH_KEY_PREFIX = "plnr.cabinet.branch."

export function readPreferredBranch(tenantId: string): string | null {
  try {
    return localStorage.getItem(`${BRANCH_KEY_PREFIX}${tenantId}`)
  } catch {
    return null
  }
}

export function writePreferredBranch(tenantId: string, branchId: string): void {
  try {
    localStorage.setItem(`${BRANCH_KEY_PREFIX}${tenantId}`, branchId)
  } catch {
    // Не запомнили — при следующем входе филиал выберется по общему правилу.
  }
}
